import { LOGO_11 } from 'constants/constants';
import React, { useState } from 'react';
import styles from './SqLogo.module.scss';

type SqLogoProps = {
  className?: string;
  url?: string;
};

const ACTIVE_LOGO = LOGO_11;

const SqLogo: React.FC<SqLogoProps> = ({ className = '', url = ACTIVE_LOGO }) => {
  const backupUrl = '/images/logos/squares-logo.webp';
  const baseCls = `${styles.SqLogo} ${className}`;

  const [logoUrl, setLogoUrl] = useState<string>(url || ACTIVE_LOGO);
  const [prevUrl, setPrevUrl] = useState(url);

  if (url !== prevUrl) {
    setPrevUrl(url);
    setLogoUrl(url || ACTIVE_LOGO);
  }


  const onImageError = () => {
    setLogoUrl(backupUrl);
  };

  return <img src={logoUrl} alt="App Logo" className={baseCls} onError={onImageError} />;
};

export default SqLogo;
